<div class="sc-dialog-wrapper" style="max-width: 480px">
  <div class="m3-dialog-header">
    <mat-icon class="m3-dialog-icon">lock_reset</mat-icon>
    <h2 class="m3-dialog-headline">{{ 'reset_password' | translate }}</h2>
    @if (!message) {
      <p class="m3-dialog-supporting-text">
        {{ 'password_reset_enter_email_message' | translate }}
      </p>
    }
  </div>
  <div
    mat-dialog-content
    style="--mdc-dialog-supporting-text-color: var(--md-sys-color-on-surface)"
  >
    <div class="r__container">
      <section class="r__middle">
        @if (resetForm && !message) {
          <form (ngSubmit)="reset()" [formGroup]="resetForm" novalidate>
            <mat-form-field class="w-100">
              <mat-label>{{ 'email' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'email' | translate"
                formControlName="email"
                type="text"
                required
              />
              <mat-error>{{
                'email_address_entry_required' | translate
              }}</mat-error>
            </mat-form-field>
          </form>
        }
        @if (message) {
          <div class="reset-card">
            <div class="reset-card__content stack s-7">
              <span>{{ message }}</span>
            </div>
          </div>
        }
      </section>
    </div>
  </div>
  <div mat-dialog-actions>
    @if (!message) {
      <button mat-button (click)="close()">
        {{ 'Cancel' | translate }}
      </button>
      <button
        mat-button
        (click)="reset()"
        [disabled]="resetForm.invalid || isLoading"
      >
        {{ 'reset_password' | translate }}
      </button>
    }
    @if (message) {
      <button
        mat-button
        (click)="close()"
        [disabled]="resetForm.invalid || isLoading"
      >
        {{ 'Back_to_login' | translate }}
      </button>
    }
  </div>
</div>
